module.exports = __webpack_public_path__ + "img/howitworks_setplan_phone2.6c3f1cbb.jpg";